import React, { Component } from 'react';
import { connect } from 'shalala';

import { useStore } from '../../../../store';
import SearchInput from '../../../../facturotopia/search-input/SearchInput';
import CustomDatePicker from '../../../reportes/clientes/components/CustomDatePicker';

class ClientesSearch extends Component {
  handleOnKeywordChange = (keyword) => {
    const { filters } = this.props.list;

    this.props.listActions.paginate({
      ...filters,
      search: keyword,
    });
  };

  handleOnDateChange = (date) => {
    const { from, to } = date;
    const { filters } = this.props.list;

    this.props.listActions.paginate({
      ...filters,
      from,
      to,
    });
  };

  handleOnSearchClear = () => {
    this.handleOnKeywordChange('');
  };

  render() {
    const {
      filters: { search },
    } = this.props.list;

    return (
      <div className="d-flex flex-column flex-sm-row">
        <CustomDatePicker onDateChange={this.handleOnDateChange} />

        <div className="pr-2"></div>

        <div className="flex-fill search-container">
          <SearchInput
            type="textarea"
            onKeywordChange={this.handleOnKeywordChange}
            onClear={this.handleOnSearchClear}
            value={search}
          />
        </div>
      </div>
    );
  }
}

const mapState = (store) => {
  return { list: store.admin.clientes.list };
};

const mapActions = (actions) => {
  return { listActions: actions.admin.clientes.list };
};

export default connect(useStore, mapState, mapActions)(ClientesSearch);
